import React, { useState } from 'react';
import { DoorOpen, ArrowRightLeft, Trash2, MapPin } from 'lucide-react';

const PortalEditor = ({
  sectors = [],
  currentSectorId,
  portals = [],
  selectedPortalTargetId,
  setSelectedPortalTargetId,
  destinationCoordinate,
  setDestinationCoordinate,
  onPlacePortal,
  onDeletePortal
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);

  return (
    <section className="space-y-4">
      <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest flex items-center gap-2">
        <DoorOpen size={14} /> Puertas / Portales
      </h3>

      {/* Selector de sector destino */}
      <div className="space-y-2">
        <label className="text-xs font-semibold text-slate-400">Sector Destino</label>
        <select
          value={selectedPortalTargetId || ''}
          onChange={(e) => setSelectedPortalTargetId(parseInt(e.target.value))}
          className="w-full bg-slate-900/50 border border-slate-700 rounded-xl p-3 text-white text-sm focus:border-game-primary focus:outline-none"
        >
          <option value="">-- Elegir sector destino --</option>
          {sectors.map(sector => (
            <option key={sector.id} value={sector.id}>
              {sector.name} {sector.id === currentSectorId ? '(Mismo sector)' : ''} {sector.sector_type === 1 ? '(Subterraneo)' : ''}
            </option>
          ))}
        </select>
      </div>

      {/* Coordenada destino */}
      {selectedPortalTargetId && (
        <div className="space-y-2">
          <label className="text-xs font-semibold text-slate-400">Coordenada Destino</label>
          <div className="flex items-center gap-2">
            <MapPin size={16} className="text-slate-500" />
            <input
              type="number"
              value={destinationCoordinate || ''}
              onChange={(e) => setDestinationCoordinate(parseInt(e.target.value))}
              placeholder="Ej: 42"
              className="flex-1 bg-slate-900/50 border border-slate-700 rounded-xl p-3 text-white text-sm focus:border-game-primary focus:outline-none"
              min="0"
            />
          </div>
          <p className="text-[10px] text-slate-600">
            Coordenada en el sector destino donde llegará el portal
          </p>
        </div>
      )}

      {/* Botón colocar portal */}
      {selectedPortalTargetId && destinationCoordinate !== null && destinationCoordinate !== undefined && (
        <button
          onClick={onPlacePortal}
          className="w-full bg-game-primary hover:bg-game-primary/80 text-white font-bold py-3 rounded-xl transition-all shadow-lg shadow-game-primary/20 flex items-center justify-center gap-2"
        >
          <DoorOpen size={16} /> Colocar Portal
        </button>
      )}

      {/* Lista de portales existentes en este sector */}
      {portals.length > 0 && (
        <div className="space-y-2">
          <label className="text-xs font-semibold text-slate-400">Portales en este Sector</label>
          <div className="max-h-48 overflow-y-auto space-y-2 custom-scrollbar">
            {portals.map((portal, idx) => {
              const targetSector = sectors.find(s => s.id === portal.id_sector_destino);
              return (
                <div 
                  key={portal.id || idx} 
                  className="p-3 bg-slate-900/50 rounded-xl border border-slate-800 space-y-2"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <ArrowRightLeft size={14} className="text-game-primary" />
                      <span className="text-sm text-white font-bold">
                        {targetSector?.name || `Sector #${portal.id_sector_destino}`}
                      </span>
                    </div>
                    {showDeleteConfirm === portal.id ? (
                      <div className="flex items-center gap-1">
                        <button
                          onClick={() => {
                            onDeletePortal(portal.id);
                            setShowDeleteConfirm(null);
                          }}
                          className="p-1 bg-rose-500 hover:bg-rose-600 rounded text-white transition-colors"
                          title="Confirmar eliminación"
                        >
                          <Trash2 size={12} />
                        </button>
                        <button
                          onClick={() => setShowDeleteConfirm(null)}
                          className="p-1 bg-slate-700 hover:bg-slate-600 rounded text-white transition-colors"
                          title="Cancelar"
                        >
                          X
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => setShowDeleteConfirm(portal.id)}
                        className="p-1 bg-slate-800 hover:bg-rose-500/20 rounded text-slate-500 hover:text-rose-400 transition-colors"
                        title="Eliminar portal"
                      >
                        <Trash2 size={12} />
                      </button>
                    )}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-slate-500">
                    <MapPin size={10} />
                    <span>Desde: Coord {portal.coordenada_origen}</span>
                    <ArrowRightLeft size={10} className="text-slate-600" />
                    <span>Hacia: Coord {portal.coordenada_destino}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Instrucciones */}
      <div className="p-3 bg-blue-500/5 rounded-xl border border-blue-500/20">
        <p className="text-[10px] text-blue-400">
          Selecciona un sector destino y coordenada, luego haz clic en el mapa para colocar el portal. Los portales conectan sectores entre sí.
        </p>
      </div>
    </section>
  );
};

export default PortalEditor;

